const actionTypes = {
    SET_REMOTE_STORY: 'REMOTE_STORY/SET',
    RESET_REMOTE_STORY: 'REMOTE_STORY/RESET',
};

export default actionTypes;
